
interface Character {
  id: string;
  name: string;
  size: number;
  svgUrl: string;
  svgUrlFail: string;
  svgIn: string;
  type: "adult" | "child" | "animal";
}

const CharactersConfig = {
  animal: [
    {
      id: "character-wolfP",
      name: "wolf",
      size: 1,
      svgUrl: "/img/carrier/characters_animal/wolf_person.svg",
      svgUrlFail: "",
      svgIn: "/img/carrier/characters_animal/wolf_person.svg",
      type: "animal"
    },
    {
      id: "character-goatP",
      name: "goat",
      size: 2,
      svgUrl: "/img/carrier/characters_animal/goat_person.svg",
      svgUrlFail: "/img/carrier/characters_animal/goat_fail.svg",
      svgIn: "/img/carrier/characters_animal/goat_person.svg",
      type: "animal"
    },
    {
      id: "character-cabbageP",
      name: "cabbage",
      size: 3,
      svgUrl: "/img/carrier/characters_animal/cabbage_person.svg",
      svgUrlFail: "/img/carrier/characters_animal/cabbage_fail.svg",
      svgIn: "/img/carrier/characters_animal/cabbage_person.svg",
      type: "animal"
    }
  ] as Character[],
  
  family: [
    {
      id: "character-mam",
      name: "mom",
      size: 1,
      svgUrl: "/img/carrier/characters_family/mom_person.svg",
      svgUrlFail: "",
      svgIn: "/img/carrier/characters_family/mom_incarrier.svg",
      type: "adult"
    },
    {
      id: "character-dad",
      name: "dad",
      size: 2,
      svgUrl: "/img/carrier/characters_family/dad_person.svg",
      svgUrlFail: "",
      svgIn: "/img/carrier/characters_family/dad_incarrier.svg",
      type: "adult"
    },
    {
      id: "character-children1",
      name: "boy1",
      size: 3,
      svgUrl: "/img/carrier/characters_family/boy1_person.svg",
      svgUrlFail: "",
      svgIn: "/img/carrier/characters_family/boy1_incarrier.svg",
      type: "child"
    },
    {
      id: "character-children2",
      name: "boy2",
      size: 3,
      svgUrl: "/img/carrier/characters_family/boy2_person.svg",
      svgUrlFail: "",
      svgIn: "/img/carrier/characters_family/boy2_incarrier.svg",
      type: "child"
    }
  ] as Character[]
};

export default CharactersConfig;